import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {Artwork} from "../../models/artwork";
import {MessagesService} from "../../services/messages/messages.service";
import {AuthService} from "../../services/auth/auth.service";

@Component({
    selector: 'app-password-recovery-modal',
    templateUrl: './password-recovery-modal.component.html',
    styleUrls: ['./password-recovery-modal.component.scss']
})
export class PasswordRecoveryModal implements OnInit {

    @Input() projectId: String;
    @Input() databaseId: String;
    @Input() artwork: Artwork;

    recoveryForm: FormGroup;
    recoveryFormIsSubmitted: boolean = false;

    constructor(
        public activeModal: NgbActiveModal,
        private formBuilder: FormBuilder,
        private authService: AuthService,
        private messagesService: MessagesService,
    ) {
    }

    ngOnInit() {
        this.recoveryForm = this.formBuilder.group({
            email: ['', [Validators.required]],
        });
    }

    submitRecoveryForm() {
        this.recoveryFormIsSubmitted = true;

        if (this.recoveryForm.invalid) return;

        this.authService.askPasswordRecovery(this.recoveryForm.controls.email.value)
            .subscribe(
                () => {
                  this.messagesService.successToast('Email sent.');
                },
              err => this.messagesService.errorToast(err),
                () => this.activeModal.close(true)
            );
    }
}
